import styled from 'styled-components';
import { BodyShort01 } from 'components/styles';
import { Input, InputBackgroundColor, InputBorder, InputFocus, NewInputBorder, NewInputFocus } from './input';
export const TextArea = styled(Input.TextArea)`
  padding: var(--spacing-04) var(--spacing-05);
  background-color: ${InputBackgroundColor};
  resize: none;
  ${BodyShort01};
  ${InputBorder};
  &:focus {
    ${InputFocus};
  }
  &.ant-input[disabled] {
    opacity: 0.5;
  }
`;
export const NewTextArea = styled(Input.TextArea)`
  padding: var(--spacing-04) var(--spacing-04);
  /* border-radius: var(--border-radius-02); */
  border-radius: var(--border-radius-small);
  resize: none;
  ${BodyShort01};
  ${NewInputBorder};
  &:focus {
    ${NewInputFocus};
  }
  &.ant-input[disabled] {
    opacity: 0.5;
  }
`;
